import api from '../../api/productFinderApi'
import queryString from 'query-string';
import searchApi from "../../api/productSearchApi";
import QueryBuilder from "../../api/QueryBuilder";
import ProductFinderEvent from "../../api/ProductFinderEvent";
import {
  selectParametersAttributefilters,
  selectParametersNotRecommendedFnd
} from '../selectors'
import { update } from 'react-spring';

export const deletePath = (filterKey) => ({
  type: 'DELETE_PATH',
  filterKey
});

export const selectFilter = (filter_id, filter_value) => ({
  type: 'SELECT_FILTER',
  id: filter_id,
  filter_value
});


export const updateFiltersByPath = (path) => ({
  type: 'UPDATE_FILTERS_BY_PATH',
  path
});


export const selectAttributeFilter = (filter_id, filter_value) => ({
  type: 'SELECT_ATTRIBUTE_FILTER',
  id: filter_id,
  filter_value
});

export const rangeAttributeFilter = (filter_id, filter_value) => ({
  type: 'RANGE_ATTRIBUTE_FILTER',
  id: filter_id,
  filter_value
});

export const selectSort = (sort_object) => ({
  type: 'SELECT_SORT',
  sort_object
});

export const updatePage = page => ({
  type: 'UPDATE_PAGE',
  page
});

export const updateAlternatePage = page => ({
  type: 'UPDATE_ALTERNATE_PAGE',
  page
});

export function setFilterMode(mode, reset) {
  return (dispatch) => {
    if (reset) {
      dispatch(clearResults());
    }
    dispatch(updateFilterMode(mode, reset));
    dispatch(setActiveMode(mode));
  }
}

export const updateFilterMode = (mode, reset) => ({
  type: 'SET_FILTER_MODE',
  mode,
  reset
})

export const setActiveMode = mode => ({
  type: 'SET_ACTIVE_MODE',
  mode
});

export const setActiveSearchMode = mode => ({
  type: 'SET_ACTIVE_SEARCH_MODE',
  mode
});

export const addRemovedAttribute = id => ({
  type: 'ADD_REMOVED_ATTRIBUTE_COLUMN',
  id
});

export const removeRemovedAttribute = id => ({
  type: 'REMOVE_REMOVED_ATTRIBUTE_COLUMN',
  id
});

export const innerResetAll = () => ({
  type: 'INNER_RESET_ALL',
});

export const resetOnSearch = () => ({
  type: 'RESET_ON_SEARCH',
});

export const resetOnFilter = () => ({
  type: 'RESET_ON_FILTER',
});

export const FilterModes = {
  DEFAULT: 'DEFAULT',
  FILTER_MODE: 'FILTER_MODE',
  SEARCH_MODE: 'SEARCH_MODE'
};

export const SearchModes = {
  TABLE: 'TABLE',
  ALTERNATIVE: 'ALTERNATIVE',
};

function applyNumericFilterQuery(filters) {
  let query = {};
  for (let [key, value] of Object.entries(filters)) {
    if (parseInt(String(value)) || Array.isArray(value)) {
      query = Object.assign({ 'filters': {} }, query);
      query.filters[key] = Array.isArray(value) ? value.filter(function (item) {
        return parseInt(item);
      }) : parseInt(String(value));
    }
  }
  return query;
}

/**
 * initial quering data from API
 * @returns 
 */
export function initialize() {
  return (dispatch, getState, path) => {
    let queryBuilder = new QueryBuilder(getState().parameters, path);
    dispatch(updateResults(queryBuilder.showResults()));
  }
}
/** 
 * makes no sense anymore. selected filter values are overwritten by the aggregations.path values in the selector.
 * @deprecated
*/
export function selectAdditionalFilters() {
  return (dispatch, getState, path) => {


    // get filters from state
    const filters = getState().parameters.filters;
    const aggregations = getState().results.aggregations
    // boolean true when filters has key 'category'
    const categoryCount = aggregations.category?.length || 0;
    console.debug("categoryCount", categoryCount);

    if (categoryCount == 1 && !Object.prototype.hasOwnProperty.call(filters, 'category')) {
      dispatch(deletePath('category'))
      dispatch(selectFilter('category', aggregations.category[0].key));
      const lineupCount = aggregations.lineup?.length || 0;
      console.debug("lineupCount", lineupCount);
      if (lineupCount == 1 && !Object.prototype.hasOwnProperty.call(filters, 'lineup')) {
        dispatch(deletePath('lineup'))
        dispatch(selectFilter('lineup', aggregations.lineup[0].key));
      }
      dispatch(resetOnFilter())

      let params = getState().parameters;
      let queryBuilder = new QueryBuilder(params, path);
      let queryPath = queryBuilder.getQueryPath();

      dispatch(requestResults());
      api(queryPath).then((result) => {
        console.debug("Update Result:", result);
        if (result) {
          dispatch(receiveResults(result, false));
        }
      })

    }

  }
}

/**
 * 
 * fetching results by the parameter or search query specified
 * 
 * NOTE: thunk middleware is injected with custom parameter url (settings.baseUrl)
 * 
 * @param {Boolean} withResults flag for display results
 * @returns 
 */
export function updateResults(withResults) {
  return (dispatch, getState, path) => {
    let params = getState().parameters;
    let queryBuilder = new QueryBuilder(params, path);
    let queryPath = queryBuilder.getQueryPath();

    withResults = queryBuilder.showResults() === false ? false : withResults;

    const searchAlternative = 'search' in params.filters && params.filters.search !== "";
    const withAlternativeResult = params.activeSearchMode === SearchModes.ALTERNATIVE;

    if (!withAlternativeResult) {
      dispatch(requestResults());
      api(queryPath).then((result) => {
        console.debug("Update Result:", result);
        if (result && result.meta.count) {
          
          dispatch(resetMaxRetries());
          dispatch(updateFiltersByPath(result.meta.aggregations.path));
          dispatch(receiveResults(result, withResults));

          // dispatch  select_filters according aggregations in result
          // for the case when selecting lineup or category directly and results.aggregations.path has no values for the parent selects.
          //dispatch(selectAdditionalFilters());

          let countRef = ProductFinder.countRef.current;

          if (withResults && countRef !== null && typeof countRef) {
            countRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }

          let datalayer = window.dataLayer;
          let event = new ProductFinderEvent(
            params.filters,
            params.attributeFilters,
            params.rangeAttributeFilters,
            result.meta.count
          );

          if (datalayer && withResults) {
            datalayer.push(event.getEvent());
          }

        } else {
          // check if product_state has set EOL and NRFND
          const attributeFilters = selectParametersAttributefilters(getState());
          const productState = attributeFilters['product_state'];
          const notRecommendedFnd = selectParametersNotRecommendedFnd(getState());

          // if EOL or NRFND is not set, fetch again with updated parameters
          if (!productState.includes('end_of_live') || !notRecommendedFnd) {
            console.debug("No results found, but product_state and not_recommended_fnd not set. Setting them now.");
            
            // set them
            dispatch(selectAttributeFilter('product_state', ['new', 'active', 'end_of_live']));
            dispatch(selectAttributeFilter('not_recommended_fnd', true));


            // ensure endless loop does not occur
            dispatch(updateMaxRetries()); // decrease max retries by 1
            const maxRetries = getState().results.maxRetries;
            if (maxRetries == 0) {
              console.warn("Max retries reached, resetting max retries and not fetching results again.");
              dispatch(resetMaxRetries());
              dispatch(resetFetching());
              dispatch(clearResults());
              return;
            } else {
              // recursive call
              dispatch(updateResults(withResults))
            }

          } else {
            // do nothing
            console.debug("No results found, but product_state and not_recommended_fnd already set.");
            dispatch(resetFetching());
            dispatch(clearResults());
            return;
          }
        }
      });
    }

    // TODO:
    // - get count of search result entries
    // - on Search tab click redirect to general search page with search param
    //

    // if param search set
    if (searchAlternative) {
      dispatch(requestAlternativeResults());
      const searchKey = getState().parameters.filters.search;
      const page = getState().parameters.alternateSearchPage;
      searchApi({
        key: searchKey,
        page: page,
        withResults: withAlternativeResult,
      }).then((result) => {
        console.debug("alternative search", result);

        if (result) {


          // if clicked on alternative tab
          if (withAlternativeResult) {

            if (!withResults) {
              // update only counter prop
              dispatch(receiveAlternativeResultsCount(result['count'], withAlternativeResult));

            } else {
              // update count and entries
              dispatch(receiveAlternativeResults(result, withAlternativeResult));
              ProductFinder.alternativeRef.current.scrollIntoView();

            }
          } else {

            // TODO dont set search entries when redirecting to general search.
            dispatch(receiveAlternativeResults(result, withAlternativeResult));
          }
        }
        else {
          dispatch(resetFetchingAlternative());
          dispatch(clearResultsAlternative());
        }
      });
    }
  }
};

const getGeneralSearchUrl = (query) => {
  const url = new URL(ProductFinder.options.settings.generalSearchPath);
  const searchParams = url.searchParams;
  searchParams.set('search', query);

  return url.toString();
}

export const redirectToGeneralSearch = () => {
  return (dispatch, getState) => {

    let params = getState().parameters;

    // redirect to general search
    const url = getGeneralSearchUrl(params.filters.search);
    window.open(url, "_blank");
  }
}

export const requestResults = () => ({
  type: 'REQUEST_RESULTS',
});

export const resetFetching = () => ({
  type: 'RESET_FETCHING',
});

export const receiveResults = (json, withResults) => ({
  loading: 'false',
  type: 'RECEIVE_RESULTS',
  json,
  withResults,
});

export const clearResults = () => ({
  type: "CLEAR_RESULTS"
});

export const requestAlternativeResults = () => ({
  type: 'REQUEST_ALTERNATIVE_RESULTS'
});

export const receiveAlternativeResults = (json, withResults) => ({
  type: 'RECEIVE_ALTERNATIVE_RESULTS',
  json,
  withResults,
});

export const receiveAlternativeResultsCount = (count, withResults) => ({
  type: 'RECEIVE_ALTERNATIVE_RESULTS_COUNT',
  count,
  withResults,
});

export const resetFetchingAlternative = () => ({
  type: 'RESET_FETCHING_ALTERNATIVE',
});

export const clearResultsAlternative = () => ({
  type: 'CLEAR_RESULTS_ALTERNATIVE',
});

export const updateMaxRetries = () => ({
  type: 'DECREASE_MAX_RETRIES',
}) 

export const resetMaxRetries = () => ({
  type: 'RESET_MAX_RETRIES',
});





